import React, { useState } from 'react'
import { formatCurrency } from '../../utilities/general-utils'
import styles from './SnowballAccountList.module.css'

const SnowballAccountList = ({ accounts, onAccountToggle }) => {
    const [excludedAccounts, setExcludedAccounts] = useState([])

    const handleExclude = (account) => {
        const updatedExcluded = [...excludedAccounts, account]
        setExcludedAccounts(updatedExcluded)
        
        const updatedAccounts = accounts.filter((acc) => acc.id !== account.id)
        onAccountToggle(updatedAccounts)
    }

    const handleInclude = (account) => {
        const updatedExcluded = excludedAccounts.filter((acc) => acc.id !== account.id)
        setExcludedAccounts(updatedExcluded)
        
        const updatedAccounts = [...accounts, account]
        onAccountToggle(updatedAccounts)
    }

    return (
        <div
            style={{
                backgroundColor: '#fff',
                padding: '1.5rem',
                margin: '0 auto 2rem',
                maxWidth: '1200px',
                width: '100%',
                border: '1px solid #ddd',
                borderRadius: '8px'
            }}
        >
            <h3 style={{ margin: '0 0 1rem', textAlign: 'center' }}>
                Debt Snowball Order
            </h3>
            <div style={{
                textAlign: 'center',
                padding: '1rem',
                backgroundColor: '#e8f4fd',
                borderRadius: '6px',
                marginBottom: '1.5rem',
                border: '1px solid #bee5eb'
            }}>
                <p style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold', color: '#0c5460' }}>
                    🎯 Automatic Snowball Ordering
                </p>
                <p style={{ margin: '0', fontSize: '0.9rem', color: '#155160' }}>
                    Accounts are automatically ordered by payoff time (shortest first) for maximum debt reduction efficiency. 
                    The account at the top will be paid off first, then its payments roll into the next account.
                </p>
            </div>
            
            <div className={styles.dragAndDropContainer}>
                {accounts.map((account, index) => (
                    <AccountItem
                        key={account.id}
                        account={account}
                        index={index}
                        onExclude={handleExclude}
                    />
                ))}
            </div>

            {excludedAccounts.length > 0 && (
                <div style={{ marginTop: '2rem' }}>
                    <h4 style={{ color: '#dc3545', textAlign: 'center' }}>
                        Excluded Accounts
                    </h4>
                    <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
                        These accounts are excluded from the debt snowball plan
                    </p>
                    <div
                        className={styles.dragAndDropContainer}
                        style={{
                            backgroundColor: '#f8d7da',
                            border: '1px solid #f5c6cb',
                            padding: '1rem',
                        }}
                    >
                        {excludedAccounts.map((account, index) => (
                            <ExcludedAccountItem
                                key={account.id}
                                account={account}
                                onInclude={handleInclude}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

const AccountItem = ({ account, index, onExclude }) => {
    const payoffTime = account.paymentSchedule ? account.paymentSchedule.length : 0;
    
    return (
        <div className={styles.item}>
            <div className={styles.itemIndex}>{index + 1}</div>
            <div className={styles.itemInfoWrap}>
                <h4 className={styles.itemName}>
                    {account.name}
                </h4>
                <p className={styles.itemInfo}>
                    {formatCurrency(account.balance)}
                    {payoffTime > 0 && (
                        <span style={{ display: 'block' }}>
                            {payoffTime} payments<br />
                        </span>
                    )}
                </p>
                <p style={{ fontSize: '0.8rem', color: '#666', margin: '0.25rem 0 0 0' }}>
                    APR: {(account.apr * 100).toFixed(2)}%
                </p>
                <button
                    className={styles.btnAddRemove}
                    onClick={() => onExclude(account)}
                    title="Exclude from snowball"
                >
                    Exclude
                </button>
            </div>
        </div>
    )
}

const ExcludedAccountItem = ({ account, onInclude }) => {
    return (
        <div className={styles.item} style={{ opacity: 0.7 }}>
            <div className={styles.itemIndex}>❌</div>
            <div className={styles.itemInfoWrap}>
                <h4 className={styles.itemName}>
                    {account.name}
                    {account.account_id && ` [${account.account_id}]`}
                </h4>
                <p className={styles.itemInfo}>
                    {formatCurrency(account.balance)} • Excluded from snowball
                </p>
                <button
                    className={styles.btnAddRemove}
                    onClick={() => onInclude(account)}
                    title="Include in snowball"
                >
                    Include
                </button>
            </div>
        </div>
    )
}

export default SnowballAccountList